module.exports = __webpack_public_path__ + "img/contemporary-music.8cab8a4a.jpeg";